// 查报告单模块
const state = {
  // 检验
  inspectionList: [],
  assayitemno: -1,
  // 检查
  checkList: [],
  inspectno: -1,
  // 体检报告详情 体检异常
  allmedicalexamsummary: ''
}

const getters = {
  checkObj: state => state.checkList.find(item => item.inspectno === state.inspectno),
  inspectionObj: state => state.inspectionList.find(item => item.assayno === state.assayitemno) || {}
}

const mutations = {
  // 检验
  updateInspectionList (state, list) {
    state.inspectionList = list
  },
  updateAssayitemno (state, assayitemno) {
    state.assayitemno = assayitemno
  },

  // 检查
  updateCheckList (state, list) {
    state.checkList = list
  },
  updateInspectno (state, inspectno) {
    state.inspectno = inspectno
  },
  setAllmedicalexamsummary (state, allmedicalexamsummary) {
    state.allmedicalexamsummary = allmedicalexamsummary
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/report.js